import REGISTER_DATA from './register';
import SIGNIN_DATA from './signin';
import FORGOT_PASSWORD_DATA from './forgot_password';
import RESET_PASSWORD_DATA from './reset_password';
import APP_DATA from './app';
import AUTH from './auth';
import ThemeOptions from './ThemeOptions';
import {
    AddressDataReducer as ADDRESS_DATA,
    AddressProofsDataReducer as ADDRESS_PROOF_DATA,
    CompanyTypesReducer as COMPANY_TYPES,
    FirmTypesReducer as FIRM_TYPES,
    WorkTypesReducer as WORK_TYPES,
    WorkScopeTypesReducer as WORK_SCOPE_TYPES
} from './app';
import PROFILE_ADDRESS from './profile_address';
import COMPANY_PROFILE_INFO from './company/profile_info';
import COMPANY_OTHER_INFO from './company/other_info';
import COMPANY_AVATAR_DATA from './company/avatar';
import COMPANY_KYC_DATA from './kyc';
import { ProfileFormSubmitReducer as COMPANY_PROFILE_SUBMIT } from './company/profile';
import USERBOX_DATA from './userbox_profile';
import COMPANY_USER_PROFILE_INFO from './company/user/profile_info';
import  { ProfileFormSubmitReducer as COMPANY_USER_PROFILE_SUBMIT } from './company/user/profile';
import COMPANY_USERS from './company/users';
import COMPANY_ADD_USER from './company/add_user';

import VENDOR_PROFILE_INFO from './vendor/profile_info';
import VENDOR_AVATAR_DATA from './vendor/avatar';
import VENDOR_KYC_DATA from './kyc';
import { ProfileFormSubmitReducer as VENDOR_PROFILE_SUBMIT } from './vendor/profile';
import VENDOR_OTHER_INFO from './vendor/other_info';

import SECURITY_INFO from './security_info';

import COMPANY_WORK_CONTRACTORS from './company/user/work/contractors';
import COMPANY_WORK_POSTS from './company/user/work/posts';
import COMPANY_WORK_RFQS from './company/user/work/rfqs';
import COMPANY_WORK_SCHEDULES from './company/user/work/schedules';

import COMPANY_RFQ_DATA from './company/rfq_info';
import VENDOR_ALL_POSTS from './vendor/posts/all';
import VENDOR_APPLIED_POSTS from './vendor/posts/applied';
import VENDOR_WORK_RFQS from './vendor/rfqs';
import VENDOR_RFQ_QUOTATION from './vendor/rfq/quotation';
import COMPANY_SCHEDULE_DATA from './company/schedule_info';
import VENDOR_MEETING_INVITES from './vendor/meeting_invites';
import VENDOR_WORK_RATES from './vendor/work_rates';
import VENDOR_DASHBOARD from './vendor/dashboard';
import COMPANY_DASHBOARD from './company/dashboard';
import COMPANY_WORK_POST_REPLIES from './company/user/work/replies';
import COMPANY_SUBSCRIPTIONS from './company/subscriptions';
import VENDOR_SUBSCRIPTIONS from './vendor/subscriptions';


export default {
    AUTH,
    APP_DATA,
    REGISTER_DATA,
    SIGNIN_DATA,
    FORGOT_PASSWORD_DATA,
    RESET_PASSWORD_DATA,
    ThemeOptions,
    ADDRESS_DATA,
    PROFILE_ADDRESS,
    COMPANY_PROFILE_INFO,
    COMPANY_KYC_DATA,
    ADDRESS_PROOF_DATA,
    COMPANY_TYPES,
    COMPANY_OTHER_INFO,
    COMPANY_AVATAR_DATA,
    COMPANY_PROFILE_SUBMIT,
    USERBOX_DATA,
    COMPANY_USER_PROFILE_INFO,
    COMPANY_USER_PROFILE_SUBMIT,
    COMPANY_USERS,
    COMPANY_ADD_USER,
    VENDOR_PROFILE_INFO,
    VENDOR_AVATAR_DATA,
    VENDOR_KYC_DATA,
    VENDOR_PROFILE_SUBMIT,
    FIRM_TYPES,
    VENDOR_OTHER_INFO,
    SECURITY_INFO,
    COMPANY_WORK_CONTRACTORS,
    COMPANY_WORK_POSTS,
    COMPANY_WORK_RFQS,
    COMPANY_WORK_SCHEDULES,
    WORK_TYPES,
    COMPANY_RFQ_DATA,
    WORK_SCOPE_TYPES,

    VENDOR_ALL_POSTS,
    VENDOR_APPLIED_POSTS,
    VENDOR_WORK_RFQS,
    VENDOR_RFQ_QUOTATION,
    COMPANY_SCHEDULE_DATA,
    VENDOR_MEETING_INVITES,
    VENDOR_WORK_RATES,
    VENDOR_DASHBOARD,
    COMPANY_DASHBOARD,
    COMPANY_WORK_POST_REPLIES,

    COMPANY_SUBSCRIPTIONS,
    VENDOR_SUBSCRIPTIONS
}
